import { useSnackbar } from "notistack";
import cloneDeep from "lodash.clonedeep";
import { useEffect, useState } from "react";

import { Button, FormControl, IconButton, MenuItem, Select, Stack } from "@mui/material";

import RefreshIcon from '@mui/icons-material/Refresh';

import TrackingOption from "./TrackingOption";

import { api } from "../../../../../utils";
import { IError } from "../../../../../models/ReportPageModels";

interface BillingClientsResponseModel {
    data: BillingClientsData;
    error: IError;
}
interface BillingClientsData {
    clients: string[];
}

interface GetTrackingResponseModel {
    data: GetTrackingData;
    error: IError;
}
interface GetTrackingData {
    catergories: TrackingCategoryModel[];
}
interface TrackingCategoryModel {
    id: string;
    name: string;
    options: TrackingOptionModel[];
}
export interface TrackingOptionModel {
    id: string;
    name: string;
    categoryId: string;
    selected: boolean;
}

interface GetTrackingByClientResponseModel {
    data: GetTrackingByClientData;
    error: IError;
}
interface GetTrackingByClientData {
    options: TrackingOptionModel[];
}

interface SaveTrackingRequestModel {
    client: string;
    options: TrackingOptionModel[];
}

interface SaveTrackingResponseModel {
    data: SaveTrackingData;
    error: IError;
}
interface SaveTrackingData {
    status: string;
}

var allTrackingOptionsCopy: TrackingOptionModel[] = [];
var clientSelectedOptions: TrackingOptionModel[] = [];

function Tracking() {
    const { enqueueSnackbar } = useSnackbar();

    const [clients, setClients] = useState<string[]>([]);
    const [selectedClient, setSelectedClient] = useState<string>("");

    const [optionsDisabled, setOptionsDisabled] = useState<boolean>(true);

    const [trackingCatergories, setTrackingCatergories] = useState<TrackingCategoryModel[]>([]);
    const [selectedTrackingCatergoryName, setSelectedTrackingCatergoryName] = useState<string>("");

    const [allTrackingOptions, setAllTrackingOptions] = useState<TrackingOptionModel[]>([]);

    useEffect(() => {
        GetClients();
        GetTracking();
    }, [])

    const GetClients = async () => {
        try {
            var resp: BillingClientsResponseModel = await api.get("api/Billing/GetClients", {
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (resp.error === null) {
                setClients(resp.data.clients);
            }
            else {
                enqueueSnackbar(resp.error.description, { variant: "error" });
            }
        } catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    function SelectClient(e: any) {
        var value = e.target.value;
        setSelectedClient(value);
        GetTrackingByClient(value);
    }

    const GetTrackingByClient = async (username: string) => {
        ClearTracking();

        try {
            var resp: GetTrackingByClientResponseModel = await api.get(`api/Billing/GetTrackingByClient?username=${username}`, {
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (resp.error === null) {
                setOptionsDisabled(false);

                AddTrackingByClient(resp.data.options);
            }
            else {
                enqueueSnackbar(resp.error.description, { variant: "error" });
            }
        } catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    const GetTracking = async () => {
        try {
            var resp: GetTrackingResponseModel = await api.get("api/Xero/GetTracking", {
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (resp.error === null) {
                setTrackingCatergories(resp.data.catergories);
            }
            else {
                enqueueSnackbar(resp.error.description, { variant: "error" });
            }
        } catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    function SelectTrackingCatergory(e: any) {
        var value = e.target.value;
        setSelectedTrackingCatergoryName(value);

        for (var i = 0; i < trackingCatergories.length; i++) {
            if (trackingCatergories[i].name === value) {
                AddTracking(trackingCatergories[i].options);
                break;
            }
        }
    }

    function ClearTracking() {
        setAllTrackingOptions([]);

        clientSelectedOptions = [];

        for (var i = 0; i < allTrackingOptionsCopy.length; i++) {
            allTrackingOptionsCopy[i].selected = false;
        }

        //UpdateTracking();
    }

    function AddTracking(array: TrackingOptionModel[]) {
        allTrackingOptionsCopy = cloneDeep(array);
        UpdateTracking();
    }

    function AddTrackingByClient(array: TrackingOptionModel[]) {
        clientSelectedOptions = cloneDeep(array);
        for (var i = 0; i < clientSelectedOptions.length; i++) {
            clientSelectedOptions[i].selected = true;
        }
        UpdateTracking();
    }

    function UpdateTracking() {
        const ignoreIndexArray: number[] = [];
        const result: TrackingOptionModel[] = [];

        for (var i = 0; i < clientSelectedOptions.length; i++) {
            var selected = clientSelectedOptions[i];
            var found = false;
            for (var j = 0; j < allTrackingOptionsCopy.length; j++) {
                var item = allTrackingOptionsCopy[j];
                if (selected.name === item.name && selected.id === item.id) {
                    result.push(selected);
                    ignoreIndexArray.push(j);
                    found = true;
                    break;
                }
            }

            // if selected not present in "all options" array
            if (!found)
                result.push(selected);
        }

        for (var i = 0; i < allTrackingOptionsCopy.length; i++) {
            if (!ignoreIndexArray.includes(i))
                result.push(allTrackingOptionsCopy[i]);
        }

        result.sort((a, b) => a.name.localeCompare(b.name));

        setAllTrackingOptions(result);
    }

    const Save = async () => {
        try {
            const selectedOptions: TrackingOptionModel[] = [];
            for (var i = 0; i < allTrackingOptions.length; i++) {
                if (allTrackingOptions[i].selected)
                    selectedOptions.push(allTrackingOptions[i]);
            }
            var body: SaveTrackingRequestModel = {
                client: selectedClient,
                options: selectedOptions
            };

            var resp: SaveTrackingResponseModel = await api.post("api/Xero/SaveTracking", {
                json: body,
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (resp.error === null) {
                enqueueSnackbar("Saved", { variant: "success" });
            }
            else {
                enqueueSnackbar(resp.error.description, { variant: "error" });
            }
        } catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    function GetOptionsHeight() {
        return window.innerHeight - 302;
    }

    return (
        <Stack>
            <Button
                variant="outlined"
                onClick={() => Save()}
                sx={{ width: '82px' }}>
                Save
            </Button>

            <span>Client</span>
            <FormControl sx={{ width: "300px" }}>
                <Select
                    value={selectedClient}
                    onChange={SelectClient}
                    size="small"
                    defaultValue=''>
                    {clients.map((el, index) => (
                        <MenuItem value={el} key={index}>{el}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            <span>Tracking Catergory</span>
            <Stack direction={"row"}>
                <FormControl sx={{ width: "250px" }}>
                    <Select
                        value={selectedTrackingCatergoryName}
                        onChange={SelectTrackingCatergory}
                        size="small">
                        {trackingCatergories.map((item, pIndex: number) => (
                            <MenuItem value={item.name} key={pIndex}>{item.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <IconButton
                    color="primary"
                    size="large"
                    onClick={() => { GetTracking() }}>
                    <RefreshIcon sx={{ fontSize: 26 }} />
                </IconButton>
            </Stack>


            {optionsDisabled ?
                <p>Please select client</p>
                :
                <>
                    <span>Tracking Options</span>
                    <Stack sx={{ height: GetOptionsHeight(), overflowX: 'auto', overflowY: 'auto', }}>
                        {allTrackingOptions.map((item, index) => (
                            <TrackingOption
                                key={index}

                                option={item} />
                        ))}
                    </Stack>
                </>
            }
        </Stack>
    )
}

export default Tracking;